module.exports = __webpack_public_path__ + "static/img/frack2 .09c38bc0.png";